import { Injectable, inject } from '@angular/core';
import { Router, UrlTree, CanActivate } from '@angular/router';
import { AuthProvider } from '../../features/auth/shared/auth-provider';

/** No bloquear la navegación al login si la API de sesión no responde. */
const SESSION_VALIDATION_TIMEOUT_MS = 2_000;

/**
 * GuestGuard — protección inversa para rutas SOLO invitadas (`/login`, `/register`).
 *
 * Complementa a AuthGuard en el eje opuesto: si ya existe una sesión activa,
 * reingresar al login/registro no tiene sentido, así que se redirige al visor
 * con un UrlTree (navegación atómica, sin segunda navegación del router).
 */
@Injectable({ providedIn: 'root' })
export class GuestGuard implements CanActivate {
  private readonly auth = inject(AuthProvider);
  private readonly router = inject(Router);

  async canActivate(): Promise<boolean | UrlTree> {
    // La rehidratación usa la API. Si esta no está disponible, el visitante
    // debe poder llegar al formulario y ver su error de conexión allí.
    await Promise.race([
      this.auth.notifier.ensureSessionValidated(),
      new Promise<void>((resolve) => setTimeout(resolve, SESSION_VALIDATION_TIMEOUT_MS)),
    ]);
    if (!this.auth.state().isAuthenticated) {
      return true;
    }
    return this.router.createUrlTree(['/viewer']);
  }
}
